import React, { Component, Fragment } from 'react';
import propTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { FormGroup, Input, Label, Popover, PopoverBody } from 'reactstrap';

import { noop } from 'lib/noop';

import styles from './RenderPreviewSelection.css';

/**
 * inputs for selecting experiment variants to hide from preview
 * @returns {React.Component} experiment selection ui
 */
export default class ExperimentSelection extends Component {
  static propTypes = {
    allExperimentVariants: propTypes.object,
    hiddenExperiments: propTypes.object,
    updateHiddenExperiments: propTypes.func
  };

  static defaultProps = {
    allExperimentVariants: {},
    hiddenExperiments: {},
    updateHiddenExperiments: noop
  };

  state = { popoverOpen: false };

  /**
   * handle input changes
   * @param {object} event - change event
   */
  handleChange = event => {
    const { name, variant } = event?.target?.dataset ?? {};
    this.props.updateHiddenExperiments({ name, variant });
  };

  togglePopover = () => this.setState(ps => ({ popoverOpen: !ps.popoverOpen }));

  render() {
    const { allExperimentVariants, hiddenExperiments } = this.props;
    const { popoverOpen } = this.state;

    if (isEmpty(allExperimentVariants)) {
      return <div data-test-id="experimentSelection-empty" />;
    }

    return (
      <Fragment>
        <span
          id="experimentsPopover"
          className={styles.wrapper}
          onClick={this.togglePopover}
          role="presentation"
          data-test-id="experimentSelection-button"
        >
          Filter Experiments
        </span>
        <Popover
          isOpen={popoverOpen}
          placement="bottom"
          target="experimentsPopover"
          toggle={this.togglePopover}
        >
          <span
            className={styles.closeButton}
            onClick={this.togglePopover}
            role="presentation"
            data-test-id="experimentSelection-close-button"
          >
            &times;
          </span>
          <PopoverBody className={styles.contentWrapper}>
            {Object.keys(allExperimentVariants).map(experiment => (
              <Fragment key={experiment}>
                <Label className="font-weight-bold my-1">{experiment}</Label>
                {allExperimentVariants[experiment].map(variant => (
                  <FormGroup key={variant} check>
                    <Label check>
                      <Input
                        checked={!hiddenExperiments?.[experiment]?.includes(variant)}
                        data-name={experiment}
                        data-variant={variant}
                        onChange={this.handleChange}
                        type="checkbox"
                      />
                      &nbsp;
                      {variant}
                    </Label>
                  </FormGroup>
                ))}
              </Fragment>
            ))}
          </PopoverBody>
        </Popover>
      </Fragment>
    );
  }
}
